import {
  REPORT_CHANGE_START_DAY,
  REPORT_CHANGE_END_DAY,
  REPORT_SET_LOADING,
  REPORT_RESET,
  REPORT_SET_ERRORS,
} from '../../constants/ActionTypes';

const reports = (
  state = {
    errors: {},
    loading: false,
    startDay: new Date(),
    endDay: new Date(),
  },
  action
) => {
  switch (action.type) {
    case REPORT_CHANGE_START_DAY:
      return { ...state, startDay: action.data };
    case REPORT_CHANGE_END_DAY:
      return { ...state, endDay: action.data };
    case REPORT_RESET:
      return {
        ...state,
        startDay: new Date(),
        endDay: new Date(),
        loading: false,
        errors: {},
      };
    case REPORT_SET_LOADING:
      return { ...state, loading: action.data };
    case REPORT_SET_ERRORS:
      return { ...state, errors: action.data };
    default:
      return state;
  }
};

export default reports;
